// @ts-nocheck
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { useInventoryStatus } from "@store/Framework/Common/Hooks/useInventoryStatus";
import storeConstants from "@store/storeConstants";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import {
    TrackEventBaseParameters,
    TrackEventParameters,
} from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEvent";

export interface TrackItemOutOfStockErrorParameters
    extends TrackEventBaseParameters<
        "item_id" | "item_name" | "out_of_stock_qty" | "available_stock_qty" | "on_demand_qty" | "user_entered_qty"
    > {
    productContext: ProductContextModel;
}

const trackItemOutOfStockError = (
    parameters: TrackItemOutOfStockErrorParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const { productContext, ...otherParameters } = parameters;
    if (!productContext.productInfo.inventory) {
        return;
    }
    const { additionalResults, qtyOnHand } = productContext.productInfo.inventory;
    const availabilityCode = additionalResults?.availabilityCode ?? "";
    const qty = productContext.productInfo?.qtyOrdered ?? 0;
    const {
        inStockAmount,
        temporaryOutOfStockAmount,
        onDemandAmount,
        shouldShowInStock,
        shouldShowTemporaryOutOfStock,
        shouldShowOnDemand,
    } = useInventoryStatus(qtyOnHand, qty, availabilityCode, additionalResults?.quantityOrdered);

    if (shouldShowTemporaryOutOfStock || shouldShowOnDemand) {
        const data: TrackEventParameters = {
            action: "out_of_stock_error",
            item_id: productContext.product.productNumber,
            item_name: productContext.product.productTitle,
            available_stock_qty: shouldShowInStock && inStockAmount > 0 ? inStockAmount : 0,
            out_of_stock_qty:
                shouldShowTemporaryOutOfStock && temporaryOutOfStockAmount > 0 ? temporaryOutOfStockAmount : 0,
            on_demand_qty: shouldShowOnDemand ? onDemandAmount : 0,
            user_entered_qty: qty,
            ...otherParameters,
        };

        return ga.track.event(data, options);
    }
};

export default trackItemOutOfStockError;
